module.exports = __webpack_public_path__ + "static/media/coupons.d98e2817.svg";